/**
 * JQuery 모듈 로딩.
 *
 * JQuery 모듈은 Selector 용도로 사용하거나,
 * 부득이하게 Kendo의 css 를 제어해야하는 경우 사용한다.
 *
 * Vue에서 JQuery를 사용하지 못할 이유는 없지만 
 * Vue로 상태 제어 및 이벤트 처리하도록 구현해둔 DOM 영역을 JQuery로 직접 건드리게 되면
 * Vue가 사용하는 가상 DOM에는 JQuery로 변경한 부분이 반영되지 않아 문제가 발생할 수 있다는 점을 인지하고 주의해서 사용해야 한다.
 */
import $ from 'jquery'

/**
 * Kendo Component 전용 함수 모듈.
 *
 * initPairTimePicker() : Kendo TimePicker 중 쌍으로 연결되는 컴포넌트에 대해 초기화 값을 세팅해주기 위한 함수.
 */
const initPairTimePicker = function(timePickerOption) {
  if(timePickerOption == undefined || timePickerOption.startTime == undefined || timePickerOption.endTime == undefined) {
      throw new Exception("잘못된 값입니다.")
  }

  if(timePickerOption.startTime.targetId == undefined || timePickerOption.endTime.targetId == undefined) {
      throw new Exception("시작시간과 종료시간에 대응할 TimePicker의 ID값이 반드시 필요합니다.")
  }

  const startTime = timePickerOption.startTime
  const endTime = timePickerOption.endTime

  let timePickerStartEl = $(startTime.targetId).data("kendoTimePicker")
  let timePickerEndEl = $(endTime.targetId).data("kendoTimePicker")

  let timeRegex = /[0-9]{1,2}:{1}[0-9]{2} (AM|PM)/g

  if(startTime.minTime != undefined && timeRegex.test(startTime.minTime)) {
    timePickerStartEl.min(startTime.minTime)
  }

  if(startTime.maxTime != undefined && timeRegex.test(startTime.maxTime)) {
    timePickerStartEl.max(startTime.maxTime)
  }

  if(startTime.initValue != undefined && timeRegex.test(startTime.initValue)) {
    timePickerStartEl.value(startTime.initValue)
  }

  if(endTime.minTime != undefined && timeRegex.test(endTime.minTime)) {
    timePickerEndEl.min(endTime.minTime)
  }

  if(endTime.maxTime != undefined && timeRegex.test(endTime.maxTime)) {
    timePickerEndEl.max(endTime.maxTime)
  }

  if(endTime.initValue != undefined && timeRegex.test(endTime.initValue)) {
    timePickerEndEl.value(endTime.initValue)
  }

  if(endTime.initValue != undefined && timeRegex.test(endTime.initValue)) {
    timePickerEndEl.value(endTime.initValue)
  }

}

export default {
  initPairTimePicker
}
